'use client';

import type { ComponentProps } from 'react';

import StreamingHomePage from '../../StreamingHomePage';
import { NEW_2026_PC_COMPONENT_MAP } from './component-map';

type New2026PcProps = Pick<ComponentProps<typeof StreamingHomePage>, 'homeListData' | 'deviceType'>;

export default function NEW_2026_PC_HomePage(props: New2026PcProps) {
  return <StreamingHomePage {...props} componentMap={NEW_2026_PC_COMPONENT_MAP} />;
}
